/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createFalse } from '../../factoriesAny.js';
export var falseDependencies = {
  createFalse: createFalse
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesFalse.generated.js
// module id = 1543
// module chunks = 0